import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import pl from './locales/pl.json';

export const SUPPORTED_LANGUAGES = ['pl', 'en'] as const;
export type Language = (typeof SUPPORTED_LANGUAGES)[number];

const STORAGE_KEY = 'dydation:language';

function detect(): Language {
  const stored = globalThis.localStorage?.getItem(STORAGE_KEY);
  if (stored === 'pl' || stored === 'en') return stored;

  return globalThis.navigator?.language?.startsWith('pl') ? 'pl' : 'en';
}

/**
 * ⚠ Mnogość jest tu ustawiona świadomie i nie jest formalnością.
 *
 * Polski ma TRZY formy liczebnikowe (1 surt / 2 surty / 5 surtów), angielski dwie.
 * i18next v21+ liczy je przez `Intl.PluralRules`, więc klucze `_one` / `_few` /
 * `_many` po prostu działają — pod warunkiem, że nikt nie sklei liczby z tekstem
 * ręcznie. Reguła: **liczba w komunikacie zawsze przez `t(key, { count })`**,
 * nigdy przez `${count} surty`.
 */
void i18n.use(initReactI18next).init({
  resources: {
    pl: { translation: pl },
    en: { translation: en },
  },
  lng: detect(),
  fallbackLng: 'en',
  interpolation: {
    // React sam escape'uje wstawiane wartości, a podwójne escapowanie zamieniłoby
    // polskie cudzysłowy i ampersandy w encje w środku zdania.
    escapeValue: false,
  },
  returnNull: false,
});

export function setLanguage(language: Language): void {
  globalThis.localStorage?.setItem(STORAGE_KEY, language);
  void i18n.changeLanguage(language);
  document.documentElement.lang = language;
}

document.documentElement.lang = i18n.language;

export { i18n };
